import { IConfig } from './IConfig'

export const configLocal: IConfig = {
  api: {
    url: 'http://localhost:3001'
  }
}
